<template>
	<div class="marketing-body">
		<div class="fx-header">
			<p>全部活动</p>
		</div>
		<div class="rule-setting" @click="openRuleDialog">
			<img src="~/images/icon/rule-setting.png" alt="" style="padding-right: 5px;">优惠规则设置
		</div>
		<div>
			<div class="fx-title">
				<span>商品促销</span>
			</div>
			<div  class="market-box">
				<div class="market-card">
					<div class="market-card-top">
						<div class="img-box">
							<img src="~/images/icon/gift.png" alt="">
						</div>
						<div class="text-box">
							<div class="text-box-title">商品买赠</div>
							<div>指定商品买赠活动</div>
						</div>
					</div>
					<div class="market-card-bottom">
						<div @click="addMarketClick" v-if="AuthorityList['08_0002_0003_00']" class="btn">+增加活动</div>
						<div v-if="AuthorityList['08_0002_0003_00'] && AuthorityList['08_0002_0000_00']" class="line"></div>
						<div @click="goMarketListClick" class="btn" v-if="AuthorityList['08_0002_0000_00']">查看活动</div>
					</div>
				</div>
				<!-- <div class="market-card mask">
					<div class="market-card-top">
						<div class="img-box">
							<img src="~/images/icon/car.png" alt="">
						</div>
						<div class="text-box">
							<div class="text-box-title">换购</div>
						</div>
					</div>
					<div class="market-card-bottom">
						<div class="btn">+增加活动</div>
						<div class="line"></div>
						<div class="btn">查看活动</div>
					</div>
				</div> -->
				<!-- <div class="market-card mask">
					<div class="market-card-top">
						<div class="img-box">
							<img src="~/images/icon/category.png" alt="">
						</div>
						<div class="text-box">
							<div class="text-box-title">组合</div>
						</div>
					</div>
					<div class="market-card-bottom">
						<div class="btn">+增加活动</div>
						<div class="line"></div>
						<div class="btn">查看活动</div>
					</div>
				</div> -->

				<div class="market-card">
					<div class="market-card-top">
						<div class="img-box">
							<img src="~/images/icon/car.png" alt="">
						</div>
						<div class="text-box">
							<div class="text-box-title">商品预售</div>
							<!-- <div>这里是简介，这里是简介这里是</div> -->
						</div>
					</div>
					<div class="market-card-bottom">
						<div class="btn" v-if="AuthorityList['08_0004_0003_00']"  @click="addPreSaleClick">+增加预售</div>
						<div v-if="AuthorityList['08_0004_0003_00'] && AuthorityList['08_0004_0000_00']" class="line"></div>
						<div class="btn" v-if="AuthorityList['08_0004_0000_00']" @click="goPreSaleClick">预售管理</div>
					</div>
				</div>
				<div class="market-card">
					<div class="market-card-top">
						<div class="img-box">
							<img src="~/images/icon/car.png" alt="">
						</div>
						<div class="text-box">
							<div class="text-box-title">商品折扣</div>
							<div>设置商品促销活动！</div>
						</div>
					</div>
					<div class="market-card-bottom">
						<div class="btn" v-if="AuthorityList['08_0007_0003_00']"  @click="addPromotionClick">+增加促销</div>
						<div v-if="AuthorityList['08_0007_0003_00'] && AuthorityList['08_0004_0000_00']" class="line"></div>
						<div class="btn" v-if="AuthorityList['08_0007_0000_00']" @click="goPromotionClick">促销管理</div>
					</div>
				</div>
			</div>
		</div>
		<div>
			<div class="fx-title">
				<span>组合促销</span>
			</div>
			<div class="market-card">
				<div class="market-card-top">
					<div class="img-box">
						<img src="~/images/icon/gift.png" alt="">
					</div>
					<div class="text-box">
						<div class="text-box-title">组合买赠</div>
						<div>多种商品买赠活动</div>
					</div>
				</div>
				<div class="market-card-bottom">
					<div @click="addMutiMarketClick" v-if="AuthorityList['08_0002_0003_00']" class="btn">+增加活动</div>
					<div v-if="AuthorityList['08_0002_0003_00'] && AuthorityList['08_0002_0000_00']" class="line"></div>
					<div @click="goMutiMarketListClick" class="btn" v-if="AuthorityList['08_0002_0000_00']">查看活动</div>
				</div>
			</div>
		</div>
		<!-- <div>
			<div class="fx-title">
				<span>订单金额促销</span>
			</div>
			<div  class="market-box">
				<div class="market-card mask">
					<div class="market-card-top">
						<div class="img-box">
							<img src="~/images/icon/calc.png" alt="">
						</div>
						<div class="text-box">
							<div class="text-box-title">满减</div>
						</div>
					</div>
					<div class="market-card-bottom">
						<div class="btn">+增加活动</div>
						<div class="line"></div>
						<div class="btn">查看活动</div>
					</div>
				</div>
			</div>
		</div> -->
		<div>
			<div class="fx-title">
				<span>会员促销</span>
			</div>
			<div  class="market-box">
				<div class="market-card" :class="matchbillcenterflag ? '' : ''">
					<div class="market-card-top">
						<div class="img-box">
							<img src="~/images/icon/car.png" alt="">
						</div>
						<div class="text-box">
							<div class="text-box-title">会员卡</div>
							<div>客户会员卡折扣设置、使用设置</div>
						</div>
					</div>
					<div class="market-card-bottom">
						<div class="btn" v-if="AuthorityList['08_0005_0003_00']"  @click="addVipClick">+增加卡型</div>
						<div v-if="AuthorityList['08_0005_0003_00'] && AuthorityList['08_0005_0000_00']" class="line"></div>
						<div class="btn" v-if="AuthorityList['08_0005_0000_00']" @click="goVipClick">会员卡管理</div>
					</div>
				</div>
			</div>
		</div>
		<div>
			<div class="fx-title">
				<span>券促销</span>
			</div>
			<div  class="market-box">
				<!-- <div class="market-card mask">
					<div class="market-card-top">
						<div class="img-box">
							<img src="~/images/icon/ticket.png" alt="">
						</div>
						<div class="text-box">
							<div class="text-box-title">买赠券</div>
						</div>
					</div>
					<div class="market-card-bottom">
						<div class="btn">+增加活动</div>
						<div class="line"></div>
						<div class="btn">查看活动</div>
					</div>
				</div> -->
				<div class="market-card" :class="matchbillcenterflag ? '' : ''">
					<div class="market-card-top">
						<div class="img-box">
							<img src="~/images/icon/ticket.png" alt="">
						</div>
						<div class="text-box">
							<div class="text-box-title">优惠券</div>
						</div>
					</div>
					<div class="market-card-bottom">
						<div @click="addDiscountClick" v-if="AuthorityList['08_0003_0003_00']" class="btn">+增加活动</div>
						<div v-if="AuthorityList['08_0003_0003_00'] && AuthorityList['08_0002_0000_00']" class="line"></div>
						<div @click="goDiscountListClick" class="btn" v-if="AuthorityList['08_0003_0000_00']">查看活动</div>
					</div>
				</div>
				<!-- <div class="market-card mask">
					<div class="market-card-top">
						<div class="img-box">
							<img src="~/images/icon/ticket.png" alt="">
						</div>
						<div class="text-box">
							<div class="text-box-title">用券结账</div>
						</div>
					</div>
					<div class="market-card-bottom">
						<div class="btn">+增加活动</div>
						<div class="line"></div>
						<div class="btn">查看活动</div>
					</div>
				</div> -->
			</div>
		</div>
		<el-dialog
			title="优惠规则设置"
			:visible.sync="ruleSettingModel"
			class="dialog-title"
			width="1260px"
			top="60px"
			:close-on-click-modal="false">
			<div style="height:600px;flex-direction: column;display:flex">
				<div style="width: 100%;
					margin-bottom: 10px;
					display: flex;
					flex-flow: row;
					align-items: center;
					justify-content: space-between;"
				>
					<el-radio-group v-model="type" size="small" @change="handleChangeType(type)">
						<el-radio-button :label="-1">全部促销</el-radio-button>
						<el-radio-button :label="3">会员促销</el-radio-button>
						<el-radio-button :label="1">券促销</el-radio-button>
					</el-radio-group>
					<el-input
						style='width:250px'
						v-model="ruleKeyword"
						placeholder="请输入名称/编号"
						size="mini"
						>
						<el-button style="height:28px" slot="append" icon="el-icon-search" @click="ruleSearchClick"></el-button>
					</el-input>
				</div>
				<div style="width: 100%;
					margin: 10px 0;
					display: flex;
					flex-flow: row;
					align-items: center;
					justify-content: space-between;"
				>
					<div class="btn-box">
						<el-button size="small" type="primary" @click="batchOpenRules(1)">批量开启</el-button>
						<el-button size="small" type="primary" style="margin-left: 10px" @click="batchOpenRules(0)">批量关闭</el-button>
					</div>
					<el-radio-group v-model="addupflag" @change="handleChangeAddupflag(addupflag)">
						<el-radio :label="-1">全部</el-radio>
						<el-radio :label="1">可叠加</el-radio>
						<el-radio :label="0">不可叠加</el-radio>
					</el-radio-group>
				</div>
				<div class="main-table-box">
					<el-table
					:stripe='true'
					size='mini'
					class="grid-content"
					:data="ruleTableData"
					:height="tableHeight"
					@selection-change="handleSelectionChange"
					border
					ref="table">
					<el-table-column
						type="selection"
						align="center"
						fixed="left"
						width="50">
					</el-table-column>
					<el-table-column
						prop="name"
						key="name"
						label="名称及编号"
						align="center"
						min-width="200">
						<template slot-scope='scope'>
							<el-tooltip placement="top">
								<div slot="content">{{scope.row.name}}</div>
								<div class="rule-box">{{scope.row.name}}</div>
							</el-tooltip>
							<div>编号：{{scope.row.code}}</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="beginDate"
						key="beginDate"
						label="促销方式、内容"
						align="center"
						min-width="150">
						<template slot-scope='scope'>
							<div v-if="scope.row.type === 1 || scope.row.type === 6">
								<div>满{{scope.row.useconditionmoney === 0 ? '任意金额' : scope.row.useconditionmoney}}减免{{scope.row.reliefmoney}}元</div>
							</div>
							<div v-if="scope.row.type === 3">
								<span v-if="scope.row.discountrule === 0">折扣 - {{scope.row.salecount}}折</span>
								<span v-if="scope.row.discountrule === 1">立减 - {{scope.row.discountmoney}}元</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="type"
						key="type"
						label="促销类别"
						align="center"
						min-width="200">
						<template slot-scope='scope'>
							<div v-if="scope.row.type === 1">满减券</div>
							<div v-if="scope.row.type === 6">商品券</div>
							<div v-if="scope.row.type === 3">会员促销</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="createdate"
						key="createdate"
						label="时间"
						align="center"
						min-width="200">
						<template slot-scope="scope">
							<div v-if="scope.row.discountdatetype === 0">永久</div>
							<div v-if="scope.row.discountdatetype === 1">{{scope.row.beginDate}}<br/>至{{scope.row.endDate}}</div>
						</template>
					</el-table-column>
					<el-table-column
						label="生效状态"
						align="center"
						min-width="150">
						<template slot-scope='scope'>
							<div v-if="scope.row.discountstate === 1" style="color:#f0902a">未生效</div>
							<div v-if="scope.row.discountstate === 0" style="color:#64b448">生效中</div>
							<!-- <div v-if="scope.row.discountstate === 2" style="color:#4899ff">已结束</div> -->
						</template>
					</el-table-column>
					<el-table-column label="是否叠加使用" min-width="200" align="center">
						<template slot-scope="scope">
							<el-switch
								v-model="scope.row.addupflag"
								active-color="#13ce66"
								inactive-color="#C0CCDA"
								:active-value="1"
								:inactive-value="0"
								@change="addupflagChange(scope.row)">
							</el-switch>
						</template>
					</el-table-column>
				</el-table>
				</div>
				<div style="width:100%;height:50px;display:flex;align-items: center;justify-content: center;">
					<el-pagination
						@size-change="ruleHandleSizeChange"
						@current-change="ruleHandleCurrentChange"
						:current-page="rulePage.number"
						:page-sizes="[20, 40, 60, 100, 300]"
						:page-size="rulePage.size"
						layout="total, sizes, prev, pager, next, jumper"
						:total="ruleTotal">
					</el-pagination>
				</div>
				<div style="display:flex;align-item:start;">
					<div>注意：</div>
					<div style="text-align: left;">
						1、用户提单时优先计算可叠加使用，优惠计算顺序：商品促销>券促销>会员促销。<br/>
						2、同促销类型默认为叠加使用，比如：预售活动、买赠活动同属商品促销类型，默认叠加使用。<br/>
						3、会员卡、优惠券目前不存在同类型叠加。说明：优惠券每笔订单限1张、会员卡每个订货客户仅有一种。
					</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>
<script>

export default {
	name: 'marketing',
	data () {
		return {
			matchbillcenterflag: false,
			AuthorityList: {
				'08_0002_0001_00': false,
				'08_0002_0002_00': false,
				'08_0002_0003_00': false,
				'08_0002_0004_00': false,
				'08_0003_0000_00': false,
				'08_0003_0003_00': false,
				'08_0002_0000_00': false,
				'08_0004_0000_00': false,
				'08_0004_0001_00': false,
				'08_0004_0002_00': false,
				'08_0004_0003_00': false,
				'08_0004_0004_00': false,
				'08_0005_0001_00': false,
				'08_0005_0002_00': false,
				'08_0005_0003_00': false,
				'08_0005_0004_00': false,
				'08_0007_0001_00': false,
				'08_0007_0002_00': false,
				'08_0007_0003_00': false,
				'08_0007_0004_00': false
			},
			ruleTableData: [],
			ids: [],
			tableHeight: '100%',
			ruleSettingModel: false,
			ruleKeyword: '',
			addupflag: -1,
			type: -1,
			ruleTotal: 0,
			rulePage: {
				number: 1,
				size: 20
			}
		}
	},
	created () {
		this.getAuthority('')
		this.getAuthority('08_0002_0000_00,08_0003_0000_00,08_0004_0000_00,08_0005_0000_00,08_0007_0000_00')
		this.checkSmallCategory()
	},
	methods: {
		checkSmallCategory () {
			// return new Promise((resolve, reject) => {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
			}).then(res => {
				this.matchbillcenterflag = res.matchbillcenterflag === 1
			})
			// })
		},
		getAuthority (id) {
			let params = {
				pId: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		addVipClick () {
			this.$fxEventBus.$emit('setMenu', '9-5')
			window.sessionStorage.removeItem('vipId')
			this.$router.push('vipDetail')
		},
		addPreSaleClick () {
			this.$fxEventBus.$emit('setMenu', '9-4')
			window.sessionStorage.removeItem('preSaleId')
			this.$router.push('preSaleDetail')
		},
		goVipClick () {
			this.$fxEventBus.$emit('setMenu', '9-5')
			this.$router.push('vipList')
		},
		goPreSaleClick () {
			this.$fxEventBus.$emit('setMenu', '9-4')
			this.$router.push('preSaleList')
		},
		addPromotionClick () {
			this.$fxEventBus.$emit('setMenu', '9-6')
			window.sessionStorage.removeItem('promotionId')
			this.$router.push('promotionDetail')
		},
		goPromotionClick () {
			this.$fxEventBus.$emit('setMenu', '9-6')
			this.$router.push('promotionList')
		},
		addDiscountClick () {
			window.sessionStorage.removeItem('discountId')
			window.sessionStorage.removeItem('discountHistory')
			this.$router.push('discountDetail')
		},
		goDiscountListClick () {
			this.$fxEventBus.$emit('setMenu', '9-3')
			this.$router.push('discountList')
		},
		addMutiMarketClick () {
			window.sessionStorage.removeItem('marketid')
			this.$router.push('mutigift')
		},
		addMarketClick () {
			window.sessionStorage.removeItem('marketid')
			this.$router.push('gift')
		},
		goMutiMarketListClick () {
			this.$fxEventBus.$emit('setMenu', '9-8')
			this.$router.push('mutimarketingManagement')
		},
		goMarketListClick () {
			this.$fxEventBus.$emit('setMenu', '9-2')
			this.$router.push('marketingManagement')
		},
		openRuleDialog () {
			this.ruleSettingModel = true
			this.tableReload()
		},
		tableReload () {
			let params = {
				historyflag: 0,
				discountState: 0,
				type: this.type,
				keyword: this.ruleKeyword,
				addupflag: this.addupflag,
				page: this.rulePage.number,
				size: this.rulePage.size
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/discount/all/list`,
				data: params
			}).then(res => {
				if (res.result) {
					this.ruleTableData = res.data.recordList
					this.ruleTotal = res.data.recordCount
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		handleChangeType (val) {
			this.type = val
			this.rulePage.number = 1
			this.tableReload()
		},
		handleChangeAddupflag (val) {
			this.addupflag = val
			this.rulePage.number = 1
			this.tableReload()
		},
		ruleSearchClick () {
			this.rulePage.number = 1
			this.rulePage.size = 20
			this.tableReload()
		},
		ruleHandleSizeChange (val) {
			this.rulePage.size = val
			this.tableReload()
		},
		ruleHandleCurrentChange (val) {
			this.rulePage.number = val
			this.tableReload()
		},
		handleSelectionChange (val) {
			this.ids = val
		},
		addupflagChange (row) {
			let paramsData = {
				id: row.id,
				type: row.type,
				addupflag: row.addupflag
			}
			let params = [paramsData]
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/discount/addUpFlag/update`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('操作成功！')
					this.tableReload()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		batchOpenRules (val) {
			let arr = []
			if (this.ids.length === 0) {
				this.$message.warning('请勾选数据')
				return false
			}
			this.ids.forEach(item => {
				let row = {
					id: item.id,
					type: item.type,
					addupflag: val
				}
				arr.push(row)
			})
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/discount/addUpFlag/update`,
				data: arr
			}).then(res => {
				if (res.result) {
					this.$message.success('操作成功！')
					this.tableReload()
				} else {
					this.$message.error(res.msg)
				}
			})
		}
	}
}
</script>
<style lang="stylus" scoped>

.marketing-body{
	display: flex;
	min-width :1000px;
	width :100%;
	flex-direction: column;
	height :100%;
	overflow-y :auto;
	padding-bottom :50px;
	border-radius :0px 0px 10px 10px;
	.main-table-box {
		flex: 1
		padding-bottom 10px
		overflow-y: auto;
	}
	.rule-setting {
		cursor: pointer;
		display: flex;
    align-items: center;
    width: 110px;
    height: 32px;
    line-height: 32px;
    font-size: 14px;
    margin-top: 10px;
		padding: 0px 15px;
    color: var(--fx-primary-color);
    border: 1px solid var(--fx-primary-color);
    border-radius: 4px;
	}
	.market-header{
		width :100%;
		min-height :40px;
		font-size :12px;
		color :#333333;
		display :flex;
		align-items :center;
		border-bottom :1px solid #EEEEEE
	}
	.market-box{
		width :100%;
		display :flex;
		flex-wrap :wrap;
		box-sizing:border-box;
		padding :10px;
	}
	.mask{
		position :relative
	}
	.mask::after{
		content :'';
		width:100%;
		top:0;
		left:0;
		height:100%;
		position :absolute;
		background-color :rgba(238, 238, 238,0.6)
	}
	.market-card{
		box-sizing :border-box;
		width :352px;
		height :160px;
		border :1px solid #EEEEEE;
		border-radius :4px;
		margin-right :20px;
		margin-bottom: 20px
	}
	.market-card-top{
		width :100%;
		height :110px;
		display :flex;
		box-sizing: border-box;
		flex-direction :row;
		align-items :center;
		padding :10px
		.img-box{
			width:40px;
			height :40px
			img{
				width :100%;
				height :100%
			}
		}
		.text-box{
			box-sizing :border-box;
			padding :10px;
			flex :1;
			display :flex;
			flex-direction :column
			color :#999999;
			font-size :12px;
			text-align :left
			.text-box-title{
				color :#333333;
				font-weight :400;
				font-size :13px;
				margin-bottom :10px;
			}
		}
	}
	.market-card-bottom{
		width :100%;
		height :48px;
		border-top :1px solid #EEEEEE;
		box-sizing :border-box;
		border-radius :4px;
		display:flex;
		flex-direction :row;
		background-color :#F8FBFF
		.btn{
			flex:1;
			display :flex;
			justify-content :center;
			align-items :center;
			font-size :14px;
			color :#595959;
			cursor :pointer
		}
		.line{
			width :1px;
			height:100%;
			background-color :#EEEEEE
		}
	}
	/deep/ .el-dialog__header {
		text-align: left;
	}
}

</style>
